import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface CaseData {
  caseId: string;
  date: string;
  autoUpdate: string;
  avmModel: string;
}

export interface AssetData {
  plotUuid?: string;
  center?: [number, number]; // [lng, lat]
  // Временно скрытые поля
  parcelId?: string;
  nib?: string;
  nomor?: string;
  address?: string;
  coordinates?: string;
}

@Component({
  selector: 'app-case-asset-info-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './case-asset-info-card.component.html',
  styleUrl: './case-asset-info-card.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseAssetInfoCardComponent {
  @Input() caseData: CaseData | null = null;
  @Input() assetData: AssetData | null = null;
  @Input() printMode: boolean = false;
  @Output() close = new EventEmitter<void>();

  activeTab = signal<'case' | 'asset'>('case');

  setActiveTab(tab: 'case' | 'asset') {
    this.activeTab.set(tab);
  }

  onSettingsClick() {
    // Placeholder for settings action
    console.log('Settings clicked');
  }

  onCloseClick() {
    this.close.emit();
  }

  onMenuClick() {
    // Placeholder for menu action
    console.log('Menu clicked');
  }

  onRowMenuClick(event: Event) {
    event.stopPropagation();
    // Placeholder for row menu action
    console.log('Row menu clicked');
  }
}

